// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


  .custom-image-hover {
    transition: box-shadow 0.2s;
    box-shadow: 0 0 0 transparent;
    position: relative;
  }
  .custom-image-hover:hover { 
    z-index: 2;
  }
  .custom-image-hover img {
    transition: transform 0.2s;
  }
  .custom-image-hover:hover img {
    transform: scale(1.1);
    box-shadow: 0 0 10px rgba(0, 253, 135, 0.5);
    
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;EAGE;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qBAAqB;IACrB,2CAA2C;;EAE7C","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n  .custom-image-hover {\n    transition: box-shadow 0.2s;\n    box-shadow: 0 0 0 transparent;\n    position: relative;\n  }\n  .custom-image-hover:hover { \n    z-index: 2;\n  }\n  .custom-image-hover img {\n    transition: transform 0.2s;\n  }\n  .custom-image-hover:hover img {\n    transform: scale(1.1);\n    box-shadow: 0 0 10px rgba(0, 253, 135, 0.5);\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
